<script>
import { Line } from 'vue-chartjs'
/* eslint-disable no-unused-vars */

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    isCurrency: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
              fontColor: "white"
          }
        },
        tooltips: {
          callbacks: {
              label: (tooltipItem, data) => {
                const totalStallTakings = data.datasets[tooltipItem.datasetIndex].data.reduce((acc, value) => acc + parseInt(value), 0);
                const currentTakings = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])
                const percentage = (currentTakings/totalStallTakings * 100).toFixed(2)
                return `${data.datasets[tooltipItem.datasetIndex].label}: ${this.isCurrency ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(currentTakings) : currentTakings} (${percentage})%`;
              }
          }
        },
        ...this.options
      }
    }
  },
  watch: {
    chartdata(newData, oldData) {
      this.renderChart(newData, this.chartOptions)
    },
  },
  mounted () {
    this.renderChart(this.chartdata, this.chartOptions)
  }
}
</script>

<style>

</style>